import { useMarketplaceModels, useModels } from 'hooks/api/useModels';

import { DisplayerProps } from '../controls/input';

export function ModelIDDisplayer({ node, value }: DisplayerProps): JSX.Element {
  const { data: userModels } = useModels();
  const { data: marketplaceModels } = useMarketplaceModels();

  const modelID = value || node.data.model_id;

  const models = (userModels ?? []).concat(marketplaceModels ?? []);
  const model = models.find(({ id }) => id === modelID);

  return model || modelID ? (
    <strong>{model?.name || modelID}</strong>
  ) : (
    <span>none</span>
  );
}

export function InferenceDisplayer({
  node,
  value,
}: DisplayerProps): JSX.Element {
  value = value || node.data.infer_on_node;
  return value ? <strong>{value}</strong> : <span>none</span>;
}

export function IntervalDisplayer({
  node,
  value,
}: DisplayerProps): JSX.Element {
  const interval = value || node.data.inference_interval;
  return (
    <strong>
      every {interval} frame{interval !== 1 && 's'}
    </strong>
  );
}
